export default "__VITE_ASSET__785baf39__"